export const VIEW_ALL_ORDERS = 'VIEW_ALL_ORDERS';
export const VIEW_ALL_GIFTS = 'VIEW_ALL_GIFTS';
export const VIEW_ALL_UNREDEEMED_GIFTS = 'VIEW_ALL_UNREDEEMED_GIFTS';
export const VIEW_ALL_SUBS = 'VIEW_ALL_SUBS';
export const LEFT_NAV_OPEN = 'LEFT_NAV_OPEN';
export const AGE_CHECK_PASSED = 'AGE_CHECK_PASSED';
export const LOGIN_ACCOUNT_NUMBER = 'LOGIN_ACCOUNT_NUMBER';
export const LOGIN_POSTAL_CODE = 'LOGIN_POSTAL_CODE';
export const IDP_ACCOUNT_INFO = 'IDP_ACCOUNT_INFO';

export type Actions = {
  VIEW_ALL_ORDERS: { type: typeof VIEW_ALL_ORDERS; payload: boolean };
  VIEW_ALL_GIFTS: { type: typeof VIEW_ALL_GIFTS; payload: boolean };
  VIEW_ALL_UNREDEEMED_GIFTS: { type: typeof VIEW_ALL_UNREDEEMED_GIFTS; payload: boolean };
  VIEW_ALL_SUBS: { type: typeof VIEW_ALL_SUBS; payload: boolean };
  LEFT_NAV_OPEN: { type: typeof LEFT_NAV_OPEN; payload: boolean };
  AGE_CHECK_PASSED: { type: typeof AGE_CHECK_PASSED; payload: boolean };
  LOGIN_ACCOUNT_NUMBER: { type: typeof LOGIN_ACCOUNT_NUMBER; payload: boolean };
  LOGIN_POSTAL_CODE: { type: typeof LOGIN_POSTAL_CODE; payload: boolean };
  IDP_ACCOUNT_INFO: { type: typeof IDP_ACCOUNT_INFO; payload: boolean };
};

export const actionCreators = {
  viewAllOrders: (payload: any): Actions[typeof VIEW_ALL_ORDERS] => ({
    type: VIEW_ALL_ORDERS,
    payload,
  }),
  viewAllGifts: (payload: any): Actions[typeof VIEW_ALL_GIFTS] => ({
    type: VIEW_ALL_GIFTS,
    payload,
  }),
  viewAllUnredeemedGifts: (payload: any): Actions[typeof VIEW_ALL_UNREDEEMED_GIFTS] => ({
    type: VIEW_ALL_UNREDEEMED_GIFTS,
    payload,
  }),
  viewAllSubs: (payload: any): Actions[typeof VIEW_ALL_SUBS] => ({
    type: VIEW_ALL_SUBS,
    payload,
  }),
  leftNavOpen: (payload: any): Actions[typeof LEFT_NAV_OPEN] => ({
    type: LEFT_NAV_OPEN,
    payload,
  }),
  ageCheckPassed: (payload: any): Actions[typeof AGE_CHECK_PASSED] => ({
    type: AGE_CHECK_PASSED,
    payload,
  }),
  loginAccountNumber: (payload: any): Actions[typeof LOGIN_ACCOUNT_NUMBER] => ({
    type: LOGIN_ACCOUNT_NUMBER,
    payload,
  }),
  loginPostalCode: (payload: any): Actions[typeof LOGIN_POSTAL_CODE] => ({
    type: LOGIN_POSTAL_CODE,
    payload,
  }),
  idpAccountInfo: (payload: any): Actions[typeof IDP_ACCOUNT_INFO] => ({
    type: IDP_ACCOUNT_INFO,
    payload,
  }),
};
